import React from 'react'

import { makeStyles, List } from '@material-ui/core'

import { ITEM_SEPARATOR } from './CustomerSidebar.helpers'
import CustomListItem from './CustomListItem'
import CustomListItemText from './CustomListItemText'
import ProductItem from './ProductItem'

import { getTariffDescription } from '../../helpers/customer.helpers'

import { mergeFixedAndInternetSubscriptions } from '~/customer/helpers/customer.helpers'
import { Package, Subscription } from '~/customer/model/customer.model'

const useStyles = makeStyles((theme) => ({
  packageTitle: {
    padding: theme.spacing(5, 10, 2, 12),
  },

  packageAddress: {
    padding: theme.spacing(1, 10, 5, 12),
  },

  listItemText: {
    margin: 0,
  },

  productItem: {
    marginBottom: '1px',
  },
}))

interface PackageItemProps {
  packageData: Package
  selectedItemsIds: string[]
  itemId: string
  onChangeSelected: (itemId: string) => void
}

const PackageItem: React.FC<PackageItemProps> = ({
  packageData,
  onChangeSelected,
  selectedItemsIds,
  itemId,
}) => {
  const classes = useStyles()

  return (
    <List disablePadding data-hook="package-item">
      <CustomListItem button className={`${classes.packageTitle}`}>
        <CustomListItemText
          className={`${classes.listItemText}`}
          primary={getTariffDescription(packageData)}
          primaryTypographyProps={{ variant: 'h6' }}
        />
      </CustomListItem>
      {packageData?.bundle.installationAddress && (
        <CustomListItem button className={`${classes.packageAddress}`}>
          <CustomListItemText
            className={`${classes.listItemText}`}
            primary={packageData?.bundle.installationAddress}
            primaryTypographyProps={{ variant: 'caption' }}
          />
        </CustomListItem>
      )}
      {mergeFixedAndInternetSubscriptions(packageData?.subscriptions).map(
        (subscription: Subscription) => {
          return (
            <ProductItem
              key={subscription.id}
              className={`${classes.productItem}`}
              subscription={subscription}
              onChangeSelected={onChangeSelected}
              selectedItemsIds={selectedItemsIds}
              itemId={`${itemId}/product${ITEM_SEPARATOR}${subscription.identificationNr}`}
            />
          )
        },
      )}
    </List>
  )
}

export default PackageItem
